// composables/useTheme.js
import { ref, watch, computed } from 'vue'

const theme = ref('system')
let mediaQueryListener = null

export function useTheme() {
  const setTheme = (newTheme) => {
    theme.value = newTheme
    if (typeof window !== 'undefined') {
      localStorage.setItem('theme', newTheme)
      updateThemeClass()
    }
  }

  const isDark = computed(() => {
    if (typeof window === 'undefined') return false
    return theme.value === 'dark' || 
      (theme.value === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
  })

  const updateThemeClass = () => {
    if (typeof window === 'undefined') return
    
    const shouldBeDark = theme.value === 'dark' || 
      (theme.value === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
    
    if (shouldBeDark) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  const initializeTheme = () => {
    if (typeof window !== 'undefined') {
      const savedTheme = localStorage.getItem('theme') || 'system'
      theme.value = savedTheme
      updateThemeClass()
      
      // Listen for system theme changes
      if (mediaQueryListener) {
        window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', mediaQueryListener)
      }
      
      mediaQueryListener = (e) => {
        if (theme.value === 'system') {
          updateThemeClass()
        }
      }
      
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', mediaQueryListener)
    }
  }

  watch(theme, updateThemeClass)

  return {
    theme,
    setTheme,
    initializeTheme,
    isDark
  }
}
